import React from "react";

const LineBreak = ({ style }) => {
  return <br />;
};

export { LineBreak };
